import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { enumDocumentType } from '@app/data-layer/enums/documents';
import { DocumentPreviewModel } from '@app/data-layer/models/documents';

@Component({
  selector: 'app-documents-preview-modal',
  templateUrl: './documents-preview-modal.component.html',
  styleUrls: ['./documents-preview-modal.component.scss'],
})
export class DocumentsPreviewModalComponent implements OnInit {
  @Input() public index: number;
  @Input() public isShowDeleteButton: boolean = true;
  @Input() public nonDeletableTypes: enumDocumentType[] = [];
  @Input() public previewDocs: DocumentPreviewModel[] = [];
  @Input() public open: boolean = false;

  @Output() public close: EventEmitter<void> = new EventEmitter<void>();
  @Output() public delete: EventEmitter<{ docId: number; shipmentId: number }> = new EventEmitter<{ docId: number; shipmentId: number }>();

  constructor(private overlayContainer: OverlayContainer) {}

  ngOnInit(): void {
    this.overlayContainer.getContainerElement().classList.add('over-modal');
  }

  public onClose() {
    this.close.emit();
  }

  public onDeleteDocument(data: { docId: number; shipmentId: number }) {
    const { docId, shipmentId } = data;

    this.delete.emit({
      docId,
      shipmentId,
    });
  }
}
